import { compose, combineReducers } from 'redux';

import userLogin from 'src/store/login';
// import { setUpdateDashboardView } from 'src/store/dashboard';
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import mdqsFilterReducer from 'src/store/login/multiDb-filters.actions';
import featureFlagsReducer from 'src/store/login/feature-flags.actions';
import adminFeatureFlagsReducer from 'src/store/login/adminfeature-flags.actions';
import createICPFilterReducer from 'src/store/login/create-icp-filters.actions';
import createICPFiltersKeyValueHashReducer from 'src/store/login/create-icp-filters-key-value-hash';
import tpAccountFilterReducer from 'src/store/login/targetProfiles-account-filters.actions';
import tpContactFilterReducer from 'src/store/login/targetProfiles-contact-filters.actions';
import webAccountFilterReducer from 'src/store/login/website-account-filters.actions';
import webAccountFiltersDataReducer from 'src/store/login/web-account-filters-data.actions';
import webContactFilterReducer from 'src/store/login/website-contact-filters.actions';
import webContactFiltersDataReducer from 'src/store/login/web-contact-filters-data.actions';
import tpAccountFiltersDataReducer from 'src/store/login/account-filters-data.actions';
import tpContactsFiltersDataReducer from 'src/store/login/contacts-filters-data.actions';
import setTPAccountsColumnsReducer from 'src/store/dashboard/tp-accountsColumn.actions';
import setTPContactsColumnsReducer from 'src/store/dashboard/tp-contactsColumn.actions';
import setWebaccountColumnsReducer from 'src/store/dashboard/webAccountsColumn.actions';
import setWebcontactColumnsReducer from 'src/store/dashboard/webContactColumn.actions';
import integrationsV2Reducer from 'src/store/integrations-v2/integrations-v2.slice';
import webTrackingReducer from 'src/store/slices/websiteTracking';
import rolePermissionsReducer from 'src/store/slices/permissions';
import scSelectedAccountsReducer from 'src/store/slices/scSelectedAccounts';
import { sourceContactsFiltersReducer } from 'src/store/slices/sourceContactsFilters';
import {
  mdqsAccountsColumnsReducer,
  mdqsContactsColumnsReducer,
} from 'src/store/slices/mdqsHeaders';
import chatbotReducer from 'src/store/chatbot/chatbot.slice';
import setRefreshUsersTableReducer from 'src/store/settings/inviteUsers.actions';
import createPlaybookFilterReducer from 'src/store/login/create-playbook-filters.actions';
import setRefreshTPAccContactsColumnsReducer from 'src/store/dashboard/refresh-tp-accountsColumn.action';
import runCampaignReducer from 'src/store/run-campaign/run-campaign.slice';
import hpmReducerV2 from 'src/store/hpm-v2/hpm.slice';
import icpScoringReducer from 'src/store/icp-scoring/icp.slice';
import setImportContactsReducer from 'src/store/dashboard/importContacts.actions';
import notificationsReducer from 'src/store/notifications/notifications.actions';
import championsTrackingImportReducer from 'src/store/champion-tracking/championImport.actions';
import websiteAgentConfigReducer from 'src/store/website-agent-config/website-agent-config.slice';
import sproutsAgentReducer from 'src/store/sprouts-agent/sprouts-agent.slice';
import setTPListPageReducer from 'src/store/dashboard/tp-list-page.actions';
import creditReducer from 'src/store/credit/credit.slice';
import listReducer from 'src/store/list/list.slice';
import { exclusionListReducer } from 'src/store/slices/exclusion';
import { archivedContactsFiltersReducer } from 'src/store/slices/archivedContactsFilters';
import { archivedAccountsFiltersReducer } from 'src/store/slices/archivedAccountFilters';
import { enrichmentLogsFiltersReducer } from 'src/store/slices/enrichmentLogsFilters';
import templatesReducer from 'src/store/templates/templates.slice';
import playbooksReducer from 'src/store/playbooks/playbooks.slice';
import googleSheetsColumnsReducer from 'src/store/workflows/googleSheetsColumns.slice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import configuredIntentTopicsReducer from 'src/store/intent-topics/intent-topics.actions';
import waterfallSourcesReducer from 'src/store/slices/waterfallSources';

import { enrichmentLogsAccountFiltersReducer } from 'src/store/slices/enrichmentLogsAccountFilters';
import userDetailsReducer from "src/store/slices/userDetails"
import askAiSignalReducer from 'src/store/ask-ai-signal/ask-ai-signal.slice';
import themeReducer from 'src/store/slices/theme';
import columnResizeReducer from 'src/store/slices/columnResize';
import allTableHeadersReducer from 'src/store/slices/allTableHeaders';

const reducers = combineReducers({
  user: userLogin,
  mdqsFilters: mdqsFilterReducer,
  mdqsAccountColumns: mdqsAccountsColumnsReducer,
  mdqsContactColumns: mdqsContactsColumnsReducer,
  featureFlags: featureFlagsReducer,
  adminFeatureFlags: adminFeatureFlagsReducer,
  createICPFilters: createICPFilterReducer,
  icpFiltersKeyValueHash: createICPFiltersKeyValueHashReducer,
  createPlaybookFilters: createPlaybookFilterReducer,
  tpAccountFilters: tpAccountFilterReducer,
  tpContactFilters: tpContactFilterReducer,
  webAccountFilters: webAccountFilterReducer,
  webAccountsFiltersConfig: webAccountFiltersDataReducer,
  webContactFilters: webContactFilterReducer,
  webContactFiltersConfig: webContactFiltersDataReducer,
  tpAccountsFiltersConfig: tpAccountFiltersDataReducer,
  tpContactsFiltersConfig: tpContactsFiltersDataReducer,
  tpAccountColumns: setTPAccountsColumnsReducer,
  tpContactColumns: setTPContactsColumnsReducer,
  webAccountColumns: setWebaccountColumnsReducer,
  webContactColumns: setWebcontactColumnsReducer,
  webTracking: webTrackingReducer,
  integrationsV2: integrationsV2Reducer,
  chatbot: chatbotReducer,
  refreshUsersTable: setRefreshUsersTableReducer,
  refreshTPAccountsContactsColumns: setRefreshTPAccContactsColumnsReducer,
  runCampaign: runCampaignReducer,
  hpmV2: hpmReducerV2,
  bulkImport: setImportContactsReducer,
  notificationsState: notificationsReducer,
  icpScoring: icpScoringReducer,
  championsTrackingImport: championsTrackingImportReducer,
  rolePermissions: rolePermissionsReducer,
  websiteAgentConfig: websiteAgentConfigReducer,
  sproutsAgent: sproutsAgentReducer,
  listPageState: setTPListPageReducer,
  scSelectedAccounts: scSelectedAccountsReducer,
  sourceContactsFilters: sourceContactsFiltersReducer,
  credit: creditReducer,
  list: listReducer,
  exclusionList: exclusionListReducer,
  archivedContactsFilters: archivedContactsFiltersReducer,
  archivedAccountsFilters: archivedAccountsFiltersReducer,
  enrichmentLogsFilters: enrichmentLogsFiltersReducer,
  templates: templatesReducer,
  playbooks: playbooksReducer,
  googleSheetsColumns: googleSheetsColumnsReducer,
  waterfallSources: waterfallSourcesReducer,
  hasConfiguredIntentTopics: configuredIntentTopicsReducer,
  enrichmentLogsAccountFilters: enrichmentLogsAccountFiltersReducer,
  userDetails: userDetailsReducer,
  askAiSignal: askAiSignalReducer,
  theme: themeReducer,
  columnResize: columnResizeReducer,
  allTableHeaders: allTableHeadersReducer,
});

const persistVersion = 4;

const persistConfig = {
  key: 'rootDeep13141$w42StoreKey',
  storage,
  blacklist: [
    // Large API response caches — refetched on mount, no value persisting
    'tpAccountsFiltersConfig',
    'tpContactsFiltersConfig',
    'webAccountsFiltersConfig',
    'webContactFiltersConfig',
    'allTableHeaders',
    'waterfallSources',
    'rolePermissions',
    'userDetails',
    'icpScoring',
    // Transient UI / operation state
    'integrationsV2',
    'chatbot',
    'askAiSignal',
    'theme',
    'notificationsState',
    'bulkImport',
    'championsTrackingImport',
    'refreshUsersTable',
    'refreshTPAccountsContactsColumns',
    'listPageState',
    'runCampaign',
    // Feature data refetched per session
    'hpmV2',
    'list',
    'credit',
    'exclusionList',
    'archivedContactsFilters',
    'archivedAccountsFilters',
    'enrichmentLogsFilters',
    'enrichmentLogsAccountFilters',
    'templates',
    'playbooks',
    'googleSheetsColumns',
    'websiteAgentConfig',
    'sproutsAgent',
  ],
  version: persistVersion,
  migrate: (state: any) => {
    if (state && state._persist.version < persistVersion) {
      // If the version is outdated, reset the reducer state
      state.hpmV2 = undefined; // Reset hpmReducer state to accommodate new properties
    }
    return Promise.resolve(state);
  },
};
const persistedReducer = persistReducer(persistConfig, reducers as any);
const dev = process.env.NODE_ENV === 'development';

// IntegrationsTools stores static config with non-serializable values:
// CardLogo (React/SVG components) and oauth.url (async PKCE function).
// These are read-only constants that never mutate through Redux actions.
// Excluding from both checks prevents false-positive warnings and deep-traversal slowdowns.
// redux-persist dispatches persist/PERSIST and persist/REHYDRATE with function
// values (register, rehydrate) — expected behaviour, not a real serialization issue.
const REDUX_PERSIST_ACTIONS = [
  'persist/PERSIST',
  'persist/REHYDRATE',
  'persist/PAUSE',
  'persist/PURGE',
  'persist/FLUSH',
  'persist/REGISTER',
];

const devMiddlewareConfig = {
  serializableCheck: {
    ignoredPaths: ['integrationsV2.integrationTools'],
    ignoredActions: [...REDUX_PERSIST_ACTIONS, 'integrationsV2/setIntegrationTools'],
  },
  immutableCheck: {
    ignoredPaths: ['integrationsV2.integrationTools'],
    warnAfter: 128,
  },
};

export const rootStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    if (dev) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { default: logger } = require('redux-logger');
      return getDefaultMiddleware(devMiddlewareConfig).concat(logger);
    }
    return getDefaultMiddleware(devMiddlewareConfig);
  },
  devTools: process.env.NODE_ENV.toString() !== 'production',
});

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
